import { PdpConfigStatus } from '@enums/pdp-config-status.enum';
import { DateHelper } from '@helpers/date.helper';
import { User, UserJson } from '@models/user';

export interface PdpConfigJson {
  id: number;
  pre_registration_at: string;
  pre_registration_by: Partial<UserJson>;
  status: PdpConfigStatus;
  invited_at: string;
  invited_by: Partial<UserJson>;
  status_at?: string;
  status_by?: Partial<UserJson>;
}

export class PdpConfig {
  constructor(
    public id?: number,
    public preRegistrationAt?: Date,
    public preRegistrationBy?: User,
    public status?: PdpConfigStatus,
    public invitedAt?: Date,
    public invitedBy?: User
  ) {}

  static fromJson(json: Partial<PdpConfigJson>): PdpConfig {
    return new PdpConfig(
      json.id,
      json.pre_registration_at ? DateHelper.fromUtc(json.pre_registration_at) : null,
      json.pre_registration_by ? User.fromJson(json.pre_registration_by) : null,
      json.status,
      json.invited_at ? DateHelper.fromUtc(json.invited_at) : null,
      json.invited_by ? User.fromJson(json.invited_by) : null
    );
  }
}
